import { BankyLogo } from '@images'
import cn from '@integrations/classnames'
import styles from '../Header.module.scss'

function BrandLogoImage() {
  return <img src={BankyLogo} alt='Logo' className={cn(styles['brand-logo-img'], 'brand-logo-img')} />
}

export default BrandLogoImage
